import {Button, Form} from "react-bootstrap";
import {useState} from "react";
import {TextField} from "@material-ui/core";
import Message from "../message";

function Pipl() {
    const apiServer = `${process.env.REACT_APP_CONFIG_API_SERVER}`

    const [pipl_email, setPipl_email] = useState('')
    const [pipl_col_name, setPipl_col_name] = useState('')
    const [pipl, setPipl] = useState('');
    const [status_pipl, setStatus_pipl] = useState("");

    const sumbit_pipl = async () => {
        setStatus_pipl("")

        if (pipl.length <= 0) {
            setStatus_pipl("Upload some files!")
        } else if (pipl_email === '' || pipl_col_name === '') {
            setStatus_pipl("Fill all fields!")
        } else {
            const pipl_formData = new FormData();
            pipl_formData.set(
                "file", pipl,
            );

            const requestOptions = {
                method: 'POST',
                body: pipl_formData
            };

            try {
                const pipl_response = await fetch(apiServer + `api/pipl/upload_file?col_name=${pipl_col_name}&email=${pipl_email}`, requestOptions);
                const pipl_status_id = await pipl_response.json();

                const pipl_status = pipl_status_id.detail ? pipl_status_id.detail : pipl_status_id
                setStatus_pipl(pipl_status)
            } catch (e) {
                console.log(e)
            }
        }
    }

    return (
        <div style={{marginTop: "20px"}}>
            <TextField style={{width: '100%'}} value={pipl_email} onChange={(e) => setPipl_email(e.target.value)}
                       id="outlined-basic" label="Email ID" variant="filled"/>
            <TextField style={{marginTop: '2px', marginBottom: '15px', width: '100%'}} value={pipl_col_name}
                       onChange={(e) => setPipl_col_name(e.target.value)} id="outlined-basic" label="Column name"
                       variant="filled"/>
            <Form.Control type="file" onChange={(e) => setPipl(e.target.files[0])}/>
            <Button variant="primary" style={{marginTop: "20px", width: "100%"}}
                    onClick={() => sumbit_pipl()}>Submit</Button>
            {Message(status_pipl, setStatus_pipl)}
        </div>
    )
}

export default Pipl